import { render, staticRenderFns } from "./DictManageV2.vue?vue&type=template&id=210c9e78&scoped=true"
import script from "./DictManageV2.vue?vue&type=script&lang=js"
export * from "./DictManageV2.vue?vue&type=script&lang=js"
import style0 from "./DictManageV2.vue?vue&type=style&index=0&id=210c9e78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210c9e78",
  null
  
)

export default component.exports